import LegalParametersView from '../LegalParametersView.vue'
import LegalParameterList  from '../Pages/LegalParameterList.vue'

// DEF-01: una sola pantalla con tres pestañas; las vigencias se crean/editan en un modal.
const routes = [
  {
    path: '/mantenimiento/parametros-legales',
    component: LegalParametersView,
    children: [
      { path: '', name: 'legal-parameter-list', component: LegalParameterList },
    ],
  },
]

export default routes
